export default {

  headline: 'SIEGENIA Mediacenter',
  search_info: ' ¿Qué está buscando?',
  back: 'volver',
  no_results: 'No se encontraron resultados. Por favor revise los criterios de búsqueda.',
  service: {
    downloads: 'Descargas',
    videos: 'Vídeos',
    faq: 'FAQ'
  },

  service_search: {
    category_placeholder: "Filtrar por categoría"
  },
  service_download: {
    select_info: 'Seleccione el área de búsqueda',
    select_productgroup: 'Seleccionar familia de productos',
    select_product: 'Seleccionar producto',
    select_type: 'Seleccionar medios',
    option_language: "idioma",
    types: {
      tec_info: 'Informaciones técnicas',
      installation: 'Instrucciones de montaje',
      planning: ' Documentos de planificación ',
      catalog: 'Folletos',
      order_forms: 'Formularios de pedido',
      maintenance: 'Cuidados, uso y mantenimiento',
      construction_drawings: 'Planos de construcción',
      software: 'Software',
      certificate: 'Certificados y directrices',
      press: 'Prensa y documentación de marketing',
      videos: 'Vídeo',
      undefined: 'Otros',
      commercial: 'Anuncio comercial',
      product_video: 'Vídeo producto',
      operating: 'Uso',
      'function': 'Función',
      'assembly': 'Montaje',
      'installation_video': 'Installación',
      'assembly_instructions': 'Plano de montaje',
      'brochure': 'Folletos',
      'tec_catalog': 'Catálogos técnicos',
      'tec_sheet': 'Hojas de datos técnicos',
      'usage_charts': 'Diagramas de aplicación',
      'profile_sheet': 'Hojas de datos de perfil',
      'operations_manual': 'Instrucciones de operación y mantenimiento',
      hardware_info: 'Información sobre el ajuste',
      'installation_suggestion': 'Sugerencia de instalación',
      'general': 'General',
      'troubleshooting': 'Fehlerbehebung',
      "smarthome:general": 'General',
      'smarthome:installation': 'Instalación',
      'smarthome:troubleshooting': 'Solución de problemas',
      'smarthome:startup': 'Puesta en marcha',
      'smarthome:operating': 'El manejo',
      'order' : 'Pedido',

    },
    filter_sorting: {
      filter: "Filtro",
      sorting: "Ordenar",
      asc: "Título ascendente (A-Z)",
      desc: "Título descendente (Z-A)",
      date_asc: "date oldest first",
      date_desc: "date newest first",
      relevance: "Relevancia",
      facet_headline: "Filtrar resultados de búsqueda",
      facet_filter_lang: "Idiomas",
      facet_filter_level_0: "Categoría",
      facet_filter_type_id: "Tipo",
      filter_remove: "Reset filter",
      show_hide: "Display filter",
    },
    result: {
      count_media: "Medios",
      show_results: "Mostrar",
      preview_type_catalog: "HTML",
      lang_not_available: "Actualmente no disponible en su idioma",
      version_info: "Este enlace lleva a la última versión de la documentación. Si necesita una versión más antigua, póngase en contacto con su asesor de clientes de SIEGENIA."
    }
  }

};
